import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const DocumentItemStyle = createStyles({
    cell: { 
        wordBreak: "break-all"
    }
});

export const useDocumentItemStyle = makeStyles((theme: Theme) => DocumentItemStyle);